export interface SetCookieOptions {
  days?: number;
  path?: string;
}

export const getCookie = (name: string, initialValue?: string): string | null => {
  if (typeof window === 'undefined') return null;

  const value = document.cookie.split('; ').reduce((r, v) => {
    const parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, '');

  return value ? value : initialValue || null;
};

export const setCookie = (name: string, value: string, options: SetCookieOptions = {}): void => {
  if (typeof window === 'undefined') return;

  const optionsWithDefaults = { days: 7, path: '/', ...options };

  const expires = new Date(Date.now() + optionsWithDefaults.days * 864e5);
  const encodedValue = encodeURIComponent(value);
  const path = optionsWithDefaults.path;

  document.cookie = `${name}=${encodedValue}; expires=${expires.toUTCString()}; path=${path};`;
};
